/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Notes_TitleInputs */

const en_us2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the model saw in the photos`)
};

const pt_br2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o modelo viu nas fotos`)
};

const es_419_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que el modelo vio en las fotos`)
};

const pt_pt2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o modelo viu nas fotos`)
};

const fr_fr2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que le modèle a vu sur les photos`)
};

const de_de2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was das Modell auf den Fotos gesehen hat`)
};

const it_it2_body_assessment_notes_title = /** @type {(inputs: Body_Assessment_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa ha visto il modello nelle foto`)
};

/**
* | output |
* | --- |
* | "What the model saw in the photos" |
*
* @param {Body_Assessment_Notes_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_notes_title = /** @type {((inputs?: Body_Assessment_Notes_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Notes_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_notes_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_notes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_notes_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_notes_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_notes_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_notes_title(inputs)
	return en_us2_body_assessment_notes_title(inputs)
});
export { body_assessment_notes_title as "body-assessment.notes_title" }